<template>
    <section class="container py-4">
        <template v-if="!loading">
        <template v-if="state">
            <div class="d-flex justify-content-center">
                <img src="/static/img/main-logo.svg" width="140" class="rounded" alt="...">
            </div>
            <div class="d-flex justify-content-center">
                <div class="text-center mt-4">
                    <h3>เอกสารแสดงความยินยอม (Consent Form) เรื่อง “การตรวจสอบประวัติอาชญากรรม”</h3>
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <p>วันที่ {{ documentDate }} </p>
            </div>
            <div class="content-text">
                <p>ตามที่ท่านในฐานะผู้ให้บริการอิสระของ บริษัท บีนีท จำกัด ทราบดีว่าคุณสมบัติของการเป็นผู้ให้บริการอิสระนั้นสำคัญอย่างยิ่ง บริษัท บีนีท จำกัด จึงได้มีความจำเป็นที่ท่านจะต้องตรวจสอบประวัติอาชญากรรมในทุกปี เพื่อความปลอดภัยและความมั่นใจของลูกค้า ซึ่งขณะนี้ถึงกำหนดแล้วที่ท่านต้องตรวจประวัติอาชญากรรม</p>
                <p>หากท่านต้องการให้บริษัท บีนีท จำกัด เป็นผู้ดำเนินการตรวจประวัติอาชญากรรมของท่าน ให้ท่านแสดงความยินยอมผ่านทางเอกสารฉบับนี้ โดยวิธีการและค่าใช้จ่ายในการดำเนินการ จะเป็นไปตามที่บริษัท บีนีท จำกัด กำหนด</p>
                <p><strong>ข้าพเจ้า นาย/นาง/นางสาว {{ professionalName }}</strong></p>
                <p>ยินยอมให้ บริษัท บีนีท จำกัด เป็นผู้ดำเนินการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้าได้ และข้าพเจ้ายินยอมให้บริษัท บีนีท จำกัด หักจากรายได้ของข้าพเจ้าในอัตราสัปดาห์ละ 25 บาท จนครบ 300 บาท เพื่อนำเงินดังกล่าวไปดำเนินการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า</p>
                <p>ทั้งนี้ ก่อนการแสดงเจตนา ข้าพเจ้าได้อ่านรายละเอียดจากเอกสารชี้แจงข้อมูล หรือได้รับคำอธิบายจาก บริษัท บีนีท จำกัด ถึง <strong>วัตถุประสงค์ในการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า</strong> และข้าพเจ้ามีความเข้าใจดีแล้ว</p>
                <p>การให้ความยินยอมของข้าพเจ้าเป็นไปด้วยความสมัครใจ ปราศจากกการบังคับหรือชักจูง และข้าพเจ้าทราบว่าข้าพเจ้าสามารถถอนความยินยอมนี้เสียเมื่อใดก็ได้ เว้นแต่ในกรณีที่มีข้อจำกัดสิทธิตามกฎหมายหรือยังมีสัญญาระหว่างข้าพเจ้ากับ บริษัท บีนีท จำกัด ที่ให้ประโยชน์แก่ข้าพเจ้าอยู่</p>
                <p>ทั้งนี้ข้าพเจ้าทราบดีว่าในกรณีที่ข้าพเจ้าไม่ได้ยินยอมให้ทาง บริษัท บีนีท จำกัด ตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า ภายในระยะเวลาที่กำหนด บริษัท บีนีท จำกัด มีสิทธิระงับการจ่ายงานและสถานภาพการเป็นผู้ให้บริการอิสระของข้าพเจ้า</p>
            </div>
            <div class="d-flex justify-content-end" v-if="!hasConsent">
                <button type="button" class="btn btn-info" @click="accepted()" >ยอมรับ</button>
            </div>
        </template>
        <template v-else>
            <div class="text-center ">
                <i class="fal fa-times-circle fa-7x text-danger"></i>
                <div class="pt-3">
                  <label>คุณแม่บ้านยังไม่มีข้อมูล</label>
                  <br />
                  <label>กรุณติดต่อเจ้าหน้าที่</label>
                </div>
            </div>
        </template>
        </template>
        <template v-else>
            <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
        </template>
       
    </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data: () => ({
    documentDate: null,
    professionalId: null,
    professionalName: null,
    state: false,
    hasConsent: false,
    loading: true
  }),
  methods: {
    async fetchCriminalHistoryCheck () {
      let params = {
        type: 'professional_id'
      }
      if (!this.professionalId) {
        this.loading = false
        this.$swal('Error', 'Invalid ID')
        return
      }
      try {
        const { data } = await axios.get(`/professionals/${this.professionalId}/criminal-history-consent`, {params})
        if (!data.error) {
          let consent = data.has_consent
          this.state = true
          this.professionalId = consent ? consent.professional_id : null
          this.professionalName = consent.professional.firstname_th + ' ' + consent.professional.lastname_th
          this.documentDate = moment(new Date()).format('DD/MM/YYYY')
          if (consent.status) {
            this.hasConsent = true
            this.documentDate = moment(consent.accepted_at).format('DD/MM/YYYY')
          }
        }
        this.loading = false
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      }
    },
    async accepted () {
      let params = {
        type: 'professional_id'
      }
      try {
        const { data } = await axios.put(`/professionals/${this.professionalId}/criminal-history-consent`, params)
        if (!data.error) {
          this.$swal('Success', 'บันทึกสำเร็จ', 'success')
        } else {
          this.$swal('Error', 'บันทึกไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่', 'error')
        }
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      }
    }
  },
  async created () {
    this.professionalId = this.$route.params.id
    if (!this.professionalId && this.$route.query.access_token && this.$route.query.professional_id) {
      const token = `Bearer ${this.$route.query.access_token}`
      const { data } = await axios.get(`/professionals/${this.$route.query.professional_id}`, { headers: { Authorization: token } })
      if (!data.error) {
        this.professionalId = this.$route.query.professional_id
      }
    }
    this.fetchCriminalHistoryCheck()
  }
}
</script>
<style scoped>
.font__bold {
    font-weight: bold;
}
.line__text {
    text-decoration: dotted;
    text-decoration-line: underline;
}
.content-text {
  text-indent: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/professional/CriminalHistoryCheck.vue